var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJumpTo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.886,
    height: 15.949,
    viewBox: "0 0 20.886 15.949",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_8111415_switchcurved_switch_next_forward_arrow_icon",
    "data-name": "8111415_switchcurved_switch_next_forward_arrow_icon",
    d: "M51.281,98.411l3,3-3,3-.959-.959,1.359-1.363h-2.01a4.013,4.013,0,0,1-2.856-1.183l-7.272-7.272a2.663,2.663,0,0,0-1.9-.785H34V91.492h3.649A4.012,4.012,0,0,1,40.5,92.676l7.272,7.271a2.662,2.662,0,0,0,1.9.785h2.01l-1.361-1.36Zm-11.74,1.537a2.7,2.7,0,0,1-1.9.784H34v1.358h3.646a4.066,4.066,0,0,0,2.857-1.181l2.453-2.444L42,97.5Zm8.237-6.314a2.7,2.7,0,0,1,1.9-.784h2.006l-1.361,1.36.959.959,3-3-3-3-.959.959,1.359,1.363H49.676a4.069,4.069,0,0,0-2.859,1.183l-2.445,2.453.963.959Z",
    transform: "translate(-33.75 -88.816)",
    fill: "#f85d18",
    stroke: "#f85d18",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJumpTo);
export default __webpack_public_path__ + "static/media/jump-to.bcf157b7dcd3fe1e935740877c411764.svg";
export { ForwardRef as ReactComponent };